import { render, staticRenderFns } from "./media_questions.vue?vue&type=template&id=e08345a4&scoped=true"
import script from "./media_questions.vue?vue&type=script&lang=js"
export * from "./media_questions.vue?vue&type=script&lang=js"
import style0 from "./media_questions.vue?vue&type=style&index=0&id=e08345a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08345a4",
  null
  
)

export default component.exports